import { FC } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import { AmlHistoryItemData } from '@/redux/models';
import { HistoryAmlHeader } from './HistoryAmlHeader';
import { HistoryAmlItem } from './HistoryAmlItem';

import styles from './HistoryAmlTable.module.sass';

interface HistoryAmlItemProps {
  canDownloadPDFReport?: boolean;
  data: AmlHistoryItemData[];
  onCheck: (uuid: string) => void;
  onDetails: (item: AmlHistoryItemData) => void;
  loading: boolean;
}

const HistoryAmlTable: FC<HistoryAmlItemProps> = (props) => {
  const { canDownloadPDFReport, data, loading, onCheck, onDetails } = props;
  const monitoringBonusCount = useAppSelector(
    profileSelectors.monitoringBonusCount,
  );

  return (
    <div className={`${styles.table} ${loading ? styles.table_blur : ''}`}>
      <HistoryAmlHeader />
      <div className={styles.table__body}>
        {data.map((item) => (
          <HistoryAmlItem
            key={item.uuid}
            canDownloadPDFReport={canDownloadPDFReport}
            item={item}
            onCheck={onCheck}
            onDetails={onDetails}
            loading={loading}
            monitoringBonuses={monitoringBonusCount}
          />
        ))}
      </div>
    </div>
  );
};

export default HistoryAmlTable;
